@use "../../../../../../../src/styles/Constants.scss" as Constants;

.fileName {
	font-weight: bold;
	line-height: 100%;
	white-space: nowrap;
}

.container {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: Constants.$val-spacing-m;
	padding-bottom: Constants.$val-spacing-l;
}